import { defineMessages } from 'react-intl';

/** The copy of the Profile tools (design artist-profile b1–b4, d2). */
export const profileToolMessages = defineMessages({
  headerName: { id: 'app.sml.promote.profile.tool.header.name', defaultMessage: 'Spotify header' },
  headerSub: {
    id: 'app.sml.promote.profile.tool.header.sub',
    defaultMessage: '2660 x 1140 · the top of your Spotify artist page · free',
  },
  headerPictureHint: {
    id: 'app.sml.promote.profile.tool.header.pictureHint',
    defaultMessage: 'Spotify asks for no text and no logos, so the header has none.',
  },
  headerPositionHint: {
    id: 'app.sml.promote.profile.tool.header.positionHint',
    defaultMessage:
      'For a photo, a bank or an AI picture: keep the subject in the green box. Spotify puts your name bottom left.',
  },
  headerGuideNote: {
    id: 'app.sml.promote.profile.tool.header.guideNote',
    defaultMessage:
      'Spotify crops each screen in its own way and does not publish the crop. The guides are our best measure; check the preview in Spotify for Artists.',
  },
  bannersName: { id: 'app.sml.promote.profile.tool.banners.name', defaultMessage: 'Banners' },
  bannersSub: {
    id: 'app.sml.promote.profile.tool.banners.sub',
    defaultMessage: 'YouTube 2560 x 1440 · Facebook 851 x 315 · free',
  },
  bannersPictureHint: {
    id: 'app.sml.promote.profile.tool.banners.pictureHintText',
    defaultMessage: 'A calm picture under your text. The text stays in the green box, so every screen shows it.',
  },
  bannerTextLabel: { id: 'app.sml.promote.profile.tool.banners.text', defaultMessage: 'Text' },
  bannerTextNone: { id: 'app.sml.promote.profile.tool.banners.text.none', defaultMessage: 'No text' },
  bannerTextName: { id: 'app.sml.promote.profile.tool.banners.text.name', defaultMessage: 'Name' },
  bannerTextRelease: { id: 'app.sml.promote.profile.tool.banners.text.release', defaultMessage: 'Name + release' },
  bannerTextLink: {
    id: 'app.sml.promote.profile.tool.banners.text.link',
    defaultMessage: 'Name + release + link',
  },
  bannerTextHint: {
    id: 'app.sml.promote.profile.tool.banners.text.hint',
    defaultMessage:
      'One choice sets both banners. Before the release day they ask for the pre-save; from the release day they say Out now.',
  },
  metaWithText: { id: 'app.sml.promote.profile.tool.meta.withText', defaultMessage: 'With text' },
  bannersPositionHint: {
    id: 'app.sml.promote.profile.tool.banners.positionHint',
    defaultMessage: 'Keep the subject in the green box: it shows on a TV, a computer and a phone.',
  },
  bannersGuideNote: {
    id: 'app.sml.promote.profile.tool.banners.guideNote',
    defaultMessage:
      'YouTube publishes its safe area (1546 x 423 in the middle). The Facebook photo place is our measure.',
  },
  tabYoutube: { id: 'app.sml.promote.profile.tool.banners.tab.youtube', defaultMessage: 'YouTube' },
  tabFacebook: { id: 'app.sml.promote.profile.tool.banners.tab.facebook', defaultMessage: 'Facebook' },
  youtubeBand: {
    id: 'app.sml.promote.profile.tool.banners.youtubeBand',
    defaultMessage: 'YouTube · the band shows on a computer',
  },
  sameForAll: { id: 'app.sml.promote.profile.tool.banners.sameForAll', defaultMessage: 'Same picture for both' },
  avatarName: { id: 'app.sml.promote.profile.tool.avatar.name', defaultMessage: 'Artist photo' },
  avatarSub: {
    id: 'app.sml.promote.profile.tool.avatar.sub',
    defaultMessage: '1500 x 1500 · Spotify, YouTube, Facebook show it round · free',
  },
  avatarPictureHint: {
    id: 'app.sml.promote.profile.tool.avatar.pictureHint',
    defaultMessage: 'A face or a clear mark. It shows small, so keep it simple.',
  },
  avatarPositionHint: {
    id: 'app.sml.promote.profile.tool.avatar.positionHint',
    defaultMessage: 'Move the photo until your face is in the middle of the circle.',
  },
  avatarGuideNote: {
    id: 'app.sml.promote.profile.tool.avatar.guideNote',
    defaultMessage: 'Every site cuts the photo round. The file is square; nothing outside the circle shows.',
  },
  avatarPhotoHint: {
    id: 'app.sml.promote.profile.tool.avatar.photoHint',
    defaultMessage: 'A square photo of 1500 px or more is best.',
  },
  avatarSmallPhoto: {
    id: 'app.sml.promote.profile.tool.avatar.smallPhoto',
    defaultMessage: 'This photo is {width} px wide. Spotify asks for 750 px or more, so the photo will look soft.',
  },
  useAsMusic24Photo: {
    id: 'app.sml.promote.profile.tool.avatar.useAsMusic24Photo',
    defaultMessage: 'Use it as my MUSIC24 photo too',
  },
  round: { id: 'app.sml.promote.profile.tool.avatar.round', defaultMessage: 'Round' },
  square: { id: 'app.sml.promote.profile.tool.avatar.square', defaultMessage: 'Square' },
  pressName: { id: 'app.sml.promote.profile.tool.press.name', defaultMessage: 'Press photos' },
  pressSub: {
    id: 'app.sml.promote.profile.tool.press.sub',
    defaultMessage: '3000 x 2000 · 2400 x 3000 · 3000 x 3000 · free',
  },
  pressPictureHint: {
    id: 'app.sml.promote.profile.tool.press.pictureHint',
    defaultMessage: 'A good photo of you. We cut it three ways for blogs, playlists and your press kit.',
  },
  pressPositionHint: {
    id: 'app.sml.promote.profile.tool.press.positionHint',
    defaultMessage: 'One point for all three crops: put it on your face.',
  },
  pressPhotoHint: {
    id: 'app.sml.promote.profile.tool.press.photoHint',
    defaultMessage: 'A photo of 3000 px or more is best.',
  },
  pressGuideNoteFree: {
    id: 'app.sml.promote.profile.tool.press.guideNoteFree',
    defaultMessage: 'Free: half-size previews with the MUSIC24 mark. Upgrade to get 3000 px files with no mark.',
  },
  pressGuideNote: {
    id: 'app.sml.promote.profile.tool.press.guideNote',
    defaultMessage: 'One photo, three crops. The guides show where each crop cuts.',
  },
  photoHintWide: {
    id: 'app.sml.promote.profile.tool.photoHintWide',
    defaultMessage: 'A photo of {width} px wide or more is best.',
  },
  smallPhoto: {
    id: 'app.sml.promote.profile.tool.smallPhoto',
    defaultMessage: 'This photo is {width} px wide. The file is {target} px wide, so the photo will look soft.',
  },
  sourceCover: { id: 'app.sml.promote.profile.tool.source.cover', defaultMessage: 'Blurred cover' },
  sourceCoverBenefit: {
    id: 'app.sml.promote.profile.tool.source.cover.benefit',
    defaultMessage: 'The cover of a release, softened. Its colours, none of its words.',
  },
  sourceCoverPlain: { id: 'app.sml.promote.profile.tool.source.coverPlain', defaultMessage: 'Release cover' },
  sourceCoverPlainBenefit: {
    id: 'app.sml.promote.profile.tool.source.coverPlain.benefit',
    defaultMessage: 'The cover of a release, as it is.',
  },
  sourcePhoto: { id: 'app.sml.promote.profile.tool.source.photo', defaultMessage: 'Your photo' },
  sourcePhotoBenefit: {
    id: 'app.sml.promote.profile.tool.source.photo.benefit',
    defaultMessage: 'A photo of you. Fans click a face first.',
  },
  sourceBank: { id: 'app.sml.promote.profile.tool.source.bank', defaultMessage: 'Picture bank' },
  sourceBankBenefit: {
    id: 'app.sml.promote.profile.tool.source.bank.benefit',
    defaultMessage: 'A picture from our bank that fits your look.',
  },
  sourceAi: { id: 'app.sml.promote.profile.tool.source.ai', defaultMessage: 'AI picture' },
  sourceAiBenefit: {
    id: 'app.sml.promote.profile.tool.source.ai.benefit',
    defaultMessage: 'A picture made in the cover editor.',
  },
  sourceTheme: { id: 'app.sml.promote.profile.tool.source.theme', defaultMessage: 'Theme colours' },
  sourceThemeBenefit: {
    id: 'app.sml.promote.profile.tool.source.theme.benefit',
    defaultMessage: 'A calm field in the colours of your look.',
  },
  releaseTitle: { id: 'app.sml.promote.profile.tool.release.title', defaultMessage: 'Which release' },
  releaseHint: {
    id: 'app.sml.promote.profile.tool.release.hint',
    defaultMessage: 'The cover is blurred across the picture. Its colours, none of its words.',
  },
  releaseHintPlain: {
    id: 'app.sml.promote.profile.tool.release.hintPlain',
    defaultMessage: 'The cover shows as it is.',
  },
  releaseNone: {
    id: 'app.sml.promote.profile.tool.release.none',
    defaultMessage: 'No release has a cover yet. Add a song with its cover, or pick another picture.',
  },
  useReleaseLook: {
    id: 'app.sml.promote.profile.tool.release.useLook',
    defaultMessage: 'Use the look of this release',
  },
  useReleaseLookNote: {
    id: 'app.sml.promote.profile.tool.release.useLookNote',
    defaultMessage: 'Off: your artist look ({artistTheme}). On: the theme of {title}.',
  },
  aiTitle: { id: 'app.sml.promote.profile.tool.ai.title', defaultMessage: 'AI pictures of {title}' },
  aiNoRelease: {
    id: 'app.sml.promote.profile.tool.ai.noRelease',
    defaultMessage: 'AI pictures come from the cover editor of a release. Add a song first.',
  },
  positionTitle: { id: 'app.sml.promote.profile.tool.position.title', defaultMessage: 'Position' },
  versionsTitle: { id: 'app.sml.promote.profile.tool.versions.title', defaultMessage: 'Versions' },
  versionsHint: {
    id: 'app.sml.promote.profile.tool.versions.hint',
    defaultMessage: 'The last 3 versions keep their files. Make it again to make a new one.',
  },
  versionsEmpty: { id: 'app.sml.promote.profile.tool.versions.empty', defaultMessage: 'No version yet.' },
  versionCurrent: {
    id: 'app.sml.promote.profile.tool.version.current',
    defaultMessage: 'Version {version} · now in use',
  },
  versionOther: { id: 'app.sml.promote.profile.tool.version.other', defaultMessage: 'Version {version}' },
  versionMadeBy: {
    id: 'app.sml.promote.profile.tool.version.madeBy',
    defaultMessage: 'Made {date} by {name} · {source}',
  },
  versionMade: { id: 'app.sml.promote.profile.tool.version.made', defaultMessage: 'Made {date} · {source}' },
  versionFileRemoved: {
    id: 'app.sml.promote.profile.tool.version.fileRemoved',
    defaultMessage: '{line} · file removed',
  },
  chipCurrent: { id: 'app.sml.promote.profile.tool.version.chip.current', defaultMessage: 'Current' },
  chipOlder: { id: 'app.sml.promote.profile.tool.version.chip.older', defaultMessage: 'Older' },
  chipNoFile: { id: 'app.sml.promote.profile.tool.version.chip.noFile', defaultMessage: 'No file' },
  useThisOne: { id: 'app.sml.promote.profile.tool.version.useThisOne', defaultMessage: 'Use this one' },
  previewTitle: { id: 'app.sml.promote.profile.tool.preview.title', defaultMessage: 'Preview' },
  cropGuides: { id: 'app.sml.promote.profile.tool.preview.guides', defaultMessage: 'Crop guides' },
  guideEveryScreen: { id: 'app.sml.promote.profile.tool.guide.everyScreen', defaultMessage: 'Every screen' },
  guideSubject: { id: 'app.sml.promote.profile.tool.guide.subject', defaultMessage: 'Keep your subject here' },
  metaJpg: { id: 'app.sml.promote.profile.tool.meta.jpg', defaultMessage: 'JPG' },
  metaNoText: { id: 'app.sml.promote.profile.tool.meta.noText', defaultMessage: 'No text' },
  metaTwoFiles: { id: 'app.sml.promote.profile.tool.meta.twoFiles', defaultMessage: '2 files' },
  metaThreeFiles: { id: 'app.sml.promote.profile.tool.meta.threeFiles', defaultMessage: '3 files' },
  metaPreview: { id: 'app.sml.promote.profile.tool.meta.preview', defaultMessage: 'Preview' },
  colours: { id: 'app.sml.promote.profile.tool.colours', defaultMessage: 'Colours' },
  coloursArtist: {
    id: 'app.sml.promote.profile.tool.colours.artist',
    defaultMessage: 'From your artist look: {theme}',
  },
  coloursRelease: { id: 'app.sml.promote.profile.tool.colours.release', defaultMessage: 'From {title}: {theme}' },
  coloursNone: {
    id: 'app.sml.promote.profile.tool.colours.none',
    defaultMessage: 'A photo shows as it is: no colours are added',
  },
  costLabel: { id: 'app.sml.promote.profile.tool.cost.label', defaultMessage: 'This costs' },
  costFree: { id: 'app.sml.promote.profile.tool.cost.free', defaultMessage: 'Free' },
  costNarrow: { id: 'app.sml.promote.profile.tool.cost.narrow', defaultMessage: 'Images cost no credits' },
  makeIt: { id: 'app.sml.promote.profile.tool.makeIt', defaultMessage: 'Make it' },
  makeBoth: { id: 'app.sml.promote.profile.tool.makeBoth', defaultMessage: 'Make both' },
  makeAllThree: { id: 'app.sml.promote.profile.tool.makeAllThree', defaultMessage: 'Make all three' },
  makingNow: { id: 'app.sml.promote.profile.tool.makingNow', defaultMessage: 'Making…' },
  madeNote: {
    id: 'app.sml.promote.profile.tool.madeNote',
    defaultMessage: 'We make it now. About 10 seconds. The current file stays until the new one is ready.',
  },
  needsRelease: { id: 'app.sml.promote.profile.tool.needs.release', defaultMessage: 'Pick a release first.' },
  needsPhoto: { id: 'app.sml.promote.profile.tool.needs.photo', defaultMessage: 'Pick or upload a photo first.' },
  needsPicture: { id: 'app.sml.promote.profile.tool.needs.picture', defaultMessage: 'Pick a picture first.' },
  back: { id: 'app.sml.promote.profile.tool.back', defaultMessage: 'Back to your profile' },
});
